import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { MailOutline } from "@material-ui/icons";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import { masterApi } from "functions/apis";
import { Redirect } from "react-router-dom";

const useStyles = makeStyles(styles);

export function DeactivateRoute(props) {
  const classes = useStyles();

  const deactivateRouteSignal = React.useRef(new AbortController());

  const { id } = useParams();

  const [data, setData] = useState(null);
  const [redirect, setRedirect] = useState(false);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    return () => deactivateRouteSignal.current.abort();
  }, []);

  useEffect(() => {
    if (id) {
      masterApi
        .get(`Routes/${id}`, {
          signal: deactivateRouteSignal.current.signal
        })
        .then(resp => {
          setData(resp);
        });
    }
  }, [id]);

  const handleDeactivate = e => {
    e.preventDefault();
    setDisabled(true);
    masterApi
      .post(
        `Routes/Deactivate`,
        { id },
        {
          signal: deactivateRouteSignal.current.signal
        }
      )
      .then(() => {
        setRedirect(true);
      })
      .catch(error => console.log(error))
      .finally(() => setDisabled(false));
  };

  return redirect ? (
    <Redirect to={"/admin/Route/InActive"} />
  ) : (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>DEACTIVATE ROUTE</h4>
          </CardHeader>
          <CardBody>
            <p>Are you sure want to deactivate this route?</p>
            <form onSubmit={handleDeactivate}>
              <Button onClick={() => props.history.goBack()} value="Back">
                BACK
              </Button>
              <Button
                disabled={disabled}
                color="info"
                type="submit"
                value="Submit"
              >
                DEACTIVATE
              </Button>
            </form>
            <GridContainer>
              <GridItem xs={6}>
                <CustomInput
                  labelText="Code"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    value: data ? data.code : "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={6}>
                <CustomInput
                  labelText="Name"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    value: data ? data.name : "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={12}>
                <CustomInput
                  labelText="Sector"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    value: data ? data.sector?.name ?? "" : "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={6}>
                <CustomInput
                  labelText="Embarkation Port"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    value: data ? data.embarkationPort.name : "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={6}>
                <CustomInput
                  labelText="Destination Port"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    value: data ? data.destinationPort.name : "",
                    disabled: true
                  }}
                />
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

DeactivateRoute.propTypes = {
  history: PropTypes.object
};
